import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

function suppressConsoleLogs(): void {
  const loggingEnabled = (window as any)?.__env?.enableLogging === 'true';
  if (!loggingEnabled) {
    window.console.log = () => {};
    window.console.warn = () => {};
    window.console.info = () => {};
    window.console.error = () => {};
  }
}
suppressConsoleLogs();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
